import { Badge } from 'antd'
import styled from 'styled-components'

const WrapBadge = styled(Badge)`
  margin-right: 10px;
`

export { WrapBadge }
